import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Document} from 'app/archivage/common/services/document/document.model';
import {DepositService} from 'app/archivage/common/services/deposit/deposit.service';
import {HelperIndividuService} from "app/archivage/common/services/helper-individu/helper-individu.service";
import {MatDialog} from "@angular/material/dialog";
import {EditDocComponent} from "app/archivage/deposit/consultation/boite/document/edit-doc/edit-doc.component";
import {DocumentService} from "app/archivage/common/services/document/document.service";
import {switchMap} from "rxjs/operators";
import {of} from "rxjs";
import {DepositState} from "app/archivage/common/services/deposit/deposit.model";

@Component({
  selector: 'app-document',
  templateUrl: './document.html',
  styleUrls: ['./document.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentComponent implements OnInit {
  @Input() document: Document;
  editMode = false;

  constructor(public depositSvc: DepositService,
              private boxSvc: DocumentService,
              private helperIndividuService: HelperIndividuService,
              private dialog: MatDialog,) {
  }

  ngOnInit(): void {
    // edit autorisé pour les gestionnaires et les documents issus d'un versement fini/archivé
    if (
      this.helperIndividuService.isGestionnaire
      && [DepositState.DONE, DepositState.ARCHIVED].includes(this.document?.box_obj?.deposit_obj?.state)
    ) {
      this.editMode = true;
    }
  }

  displayNature() {
    if (this.document?.dua_obj) {
      return `${this.document?.dua_obj?.nature}`;
    }
    return '';
  }

  displayDuration() {
    if (this.document?.dua_obj) {
      if (this.document.dua_obj?.without_duration !== null && this.document.dua_obj?.without_duration) {
        return `N/A`;
      } else {
        return `${this.document?.dua_obj?.duration}`;
      }
    }
    return '';
  }

  editDocument(): void {
    const dialogRef = this.dialog.open(EditDocComponent, {
      //width: '550px',
      data: this.document,
      disableClose: false
    });
    dialogRef.afterClosed().pipe(
      switchMap(
        (result: Document) => {
          if (result) {
            const data = {id: result.id, dua: result.dua};
            return this.boxSvc.patch(data);
          } else {
            return of(null);
          }
        }
      )
    ).subscribe();
  }
}
